import styled from 'styled-components';

export const Details = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  padding-left: 5rem;
`;
export const DetailHeader = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.ui.subheader};
  margin-bottom: 10px;
  font-weight: bold;
`;
export const Info = styled.p`
  color: ${({ theme }) => theme.ui.subheader};
`;

export const SubHeader = styled.p`
  font-size: 20px;
  text-align: center;
  color: ${({ theme }) => theme.ui.subheader};
`;